/* FUSFIT · Botón «Compartir» (borrador). Un solo archivo para la ficha de producto y para las tarjetas de producto.
   Teléfono: menú nativo (navigator.share). Computadora: menú pequeño con WhatsApp, Facebook, X y «Copiar enlace».
   Estilos en assets/ff-compartir.css. No toca ningún formulario ni el agregado rápido: solo añade un botón. */
(function () {
  'use strict';
  if (window.__ffCompartir) return;
  window.__ffCompartir = true;

  var ICONO = '<svg class="ff-comp__ic" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7"/><path d="M16 6l-4-4-4 4"/><path d="M12 2v14"/></svg>';

  function limpio(t) { return (t || '').replace(/\s+/g, ' ').trim(); }

  /* URL del producto + utm; la variante va si se conoce. */
  function armarUrl(ruta, variante, campana) {
    var u = new URL(ruta, location.origin);
    var out = new URL(location.origin + u.pathname);
    var v = variante || u.searchParams.get('variant');
    if (v) out.searchParams.set('variant', v);
    out.searchParams.set('utm_source', 'compartir');
    out.searchParams.set('utm_medium', 'social');
    out.searchParams.set('utm_campaign', campana);
    return out.toString();
  }

  /* ── Menú pequeño (computadora): uno solo para toda la página ── */
  var menu, vivo, activo = null, datos = null, temporizador;
  function crearMenu() {
    if (menu) return;
    menu = document.createElement('div');
    menu.className = 'ff-comp__menu'; menu.setAttribute('role', 'menu'); menu.setAttribute('aria-label', 'Compartir este producto'); menu.hidden = true;
    menu.innerHTML =
      '<a role="menuitem" class="ff-comp__op" data-red="wa" target="_blank" rel="noopener noreferrer">WhatsApp</a>' +
      '<a role="menuitem" class="ff-comp__op" data-red="fb" target="_blank" rel="noopener noreferrer">Facebook</a>' +
      '<a role="menuitem" class="ff-comp__op" data-red="x" target="_blank" rel="noopener noreferrer">X</a>' +
      '<button type="button" role="menuitem" class="ff-comp__op" data-red="copiar">Copiar enlace</button>';
    vivo = document.createElement('span'); vivo.className = 'ff-comp__vivo'; vivo.setAttribute('role', 'status'); vivo.setAttribute('aria-live', 'polite');
    document.body.appendChild(menu); document.body.appendChild(vivo);

    var opCopiar = menu.querySelector('[data-red="copiar"]');
    opCopiar.addEventListener('click', function (e) {
      e.stopPropagation();
      copiar(datos.url).then(function () {
        opCopiar.textContent = '¡Copiado!'; vivo.textContent = 'Enlace copiado';
        clearTimeout(temporizador);
        temporizador = setTimeout(function () { vivo.textContent = ''; cerrar(true); }, 1500);
      }, function () { opCopiar.textContent = 'No se pudo copiar'; });
    });
    menu.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target.closest && e.target.closest('a')) setTimeout(function () { cerrar(false); }, 0);
    });
    menu.addEventListener('keydown', function (e) {
      var lista = Array.prototype.slice.call(menu.querySelectorAll('[role="menuitem"]')), i = lista.indexOf(document.activeElement);
      if (e.key === 'Escape') { e.preventDefault(); cerrar(true); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); lista[(i + 1) % lista.length].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); lista[(i - 1 + lista.length) % lista.length].focus(); }
      else if (e.key === 'Tab') { cerrar(false); }
    });
    document.addEventListener('click', function (e) { if (activo && !menu.contains(e.target) && !activo.contains(e.target)) cerrar(false); });
    document.addEventListener('keydown', function (e) { if (activo && e.key === 'Escape') { e.preventDefault(); cerrar(true); } });
    window.addEventListener('resize', function () { cerrar(false); });
    window.addEventListener('scroll', function () { if (activo) cerrar(false); }, { passive: true });
  }
  function cerrar(devolverFoco) {
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    var b = activo; activo = null;
    if (b) { b.setAttribute('aria-expanded', 'false'); if (devolverFoco) b.focus(); }
  }
  function abrirMenu(btn, d) {
    crearMenu();
    datos = d; activo = btn;
    var txt = d.frase;
    menu.querySelector('[data-red="wa"]').href = 'https://wa.me/?text=' + encodeURIComponent(txt + ' ' + d.url);
    menu.querySelector('[data-red="fb"]').href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(d.url);
    menu.querySelector('[data-red="x"]').href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(txt) + '&url=' + encodeURIComponent(d.url);
    menu.querySelector('[data-red="copiar"]').textContent = 'Copiar enlace';
    menu.hidden = false; btn.setAttribute('aria-expanded', 'true');
    var r = btn.getBoundingClientRect(), w = menu.offsetWidth, h = menu.offsetHeight;
    var izq = Math.max(8, Math.min(r.right - w, innerWidth - w - 8));
    var arriba = r.bottom + 6 + h > innerHeight - 8 ? Math.max(8, r.top - h - 6) : r.bottom + 6;
    menu.style.left = izq + 'px'; menu.style.top = arriba + 'px';
    menu.querySelector('[role="menuitem"]').focus();
  }

  function copiar(texto) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(texto).catch(function () { return copiarViejo(texto); });
    }
    return copiarViejo(texto);
  }
  function copiarViejo(texto) {
    return new Promise(function (ok, no) {
      var t = document.createElement('textarea');
      t.value = texto; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
      document.body.appendChild(t); t.select();
      var bien = false;
      try { bien = document.execCommand('copy'); } catch (e) { bien = false; }
      t.remove();
      bien ? ok() : no(new Error('copiar'));
    });
  }

  /* Clic en un botón de compartir: nativo si existe; si no (o si falla de verdad), el menú pequeño. */
  function alPulsar(btn, leer) {
    return function (e) {
      e.stopPropagation(); e.preventDefault();
      if (activo === btn) { cerrar(true); return; }
      var d = leer();
      if (typeof navigator.share === 'function') {
        var p;
        try { p = navigator.share({ title: d.titulo, text: d.frase, url: d.url }); } catch (err) { abrirMenu(btn, d); return; }
        if (p && p.catch) p.catch(function (err) { if (err && err.name !== 'AbortError') abrirMenu(btn, d); });
      } else {
        abrirMenu(btn, d);
      }
    };
  }
  function crearBoton(clase, etiqueta, conTexto) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = clase; b.setAttribute('aria-label', etiqueta); b.setAttribute('aria-haspopup', 'menu'); b.setAttribute('aria-expanded', 'false');
    b.innerHTML = ICONO + (conTexto ? '<span class="ff-comp__txt">Compartir</span>' : '');
    return b;
  }

  /* ── Ficha de producto: arriba a la derecha del título ── */
  function montarFicha() {
    var h1 = document.querySelector('.product-details h1');
    if (!h1 || document.querySelector('.ff-comp')) return;
    var host = h1.parentElement && h1.parentElement.parentElement;
    if (!host) return;
    host.classList.add('ff-comp-host');
    var caja = document.createElement('div'); caja.className = 'ff-comp';
    var b = crearBoton('ff-comp__btn', 'Compartir este producto', true);
    var leer = function () {
      var t = limpio(h1.textContent) || document.title;
      var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var v = new URLSearchParams(location.search).get('variant') || (inp && inp.value) || '';
      return { titulo: t, frase: 'Mira esto en FUSFIT: ' + t, url: armarUrl(location.pathname, v, 'ficha') };
    };
    caja.appendChild(b); host.appendChild(caja);
    b.addEventListener('click', alPulsar(b, leer));
  }

  /* ── Tarjetas de producto (la de FUSFIT y la del tema): un botón sobre la foto ── */
  function montarTarjetas(raiz) {
    var tarjetas = (raiz || document).querySelectorAll('product-card:not([data-ff-comp])');
    if (raiz && raiz.matches && raiz.matches('product-card:not([data-ff-comp])')) tarjetas = [raiz];
    for (var i = 0; i < tarjetas.length; i++) {
      var c = tarjetas[i];
      c.setAttribute('data-ff-comp', '');
      var enlace = c.querySelector('a[ref="productCardLink"], a[href*="/products/"]');
      var foto = c.querySelector('.ff-card__img, .card-gallery');
      if (!enlace || !foto || !/\/products\//.test(enlace.getAttribute('href') || '')) continue;
      var b = crearBoton('ff-comp__tarj', 'Compartir este producto', false);
      foto.appendChild(b);
      b.addEventListener('click', alPulsar(b, (function (card, a) {
        return function () {
          var tt = card.querySelector('.ff-card__title, .product-card__title, .card__title');
          var t = limpio(tt ? tt.textContent : a.textContent) || limpio(a.getAttribute('aria-label'));
          return { titulo: t, frase: 'Mira esto en FUSFIT: ' + t, url: armarUrl(a.getAttribute('href'), '', 'tarjeta') };
        };
      })(c, enlace)));
    }
  }

  /* FUSFIT velocidad 31-oct: antes, con CADA cambio de la página (los cronómetros cambian texto cada segundo) se volvían a
     revisar las ≈205 tarjetas y se buscaba el título de la ficha. Ahora se miran solo los nodos NUEVOS que sean
     elementos (los cambios de texto no traen ninguno) y, dentro de ellos, sus tarjetas. */
  function montar() { montarFicha(); montarTarjetas(); }
  function iniciar() {
    montar();
    var nuevos = [], pend = false;
    function procesar() {
      pend = false;
      var lista = nuevos; nuevos = [];
      var ficha = !document.querySelector('.ff-comp');
      for (var i = 0; i < lista.length; i++) {
        var n = lista[i];
        if (!n.isConnected) continue;
        if (ficha && (n.tagName === 'H1' || n.querySelector('h1'))) { montarFicha(); ficha = !document.querySelector('.ff-comp'); }
        if (n.tagName === 'PRODUCT-CARD' || n.querySelector('product-card')) montarTarjetas(n);
      }
    }
    new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        var a = cambios[i].addedNodes;
        for (var j = 0; j < a.length; j++) if (a[j].nodeType === 1) nuevos.push(a[j]);
      }
      if (!nuevos.length || pend) return;
      pend = true;
      requestAnimationFrame(procesar);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
